export const locale = {
    lang: 'en',
    data: {
      'PRINCIPAL': {
        'TITULO': 'Survey status',
        'SUBTITULO': 'You can review and follow up on the information of the surveys applied in one or more products of the company',
        'COPY_URL_RES':'Copy URL from SuccesGo',
      },
      'MENU_PRODUCTOS': {
        'TITULO': 'Products purchased',
        'CARGANDO': 'Loading product list',
        'NOMBREPULSO': 'Pulse',
        'TIPOS': {
          'certificar': {
            'NOMBRE': 'Certify',
            'SUBTIPOS': {
              'v1': 'Certify v1',
              'v2': 'Certify v2.0',
              'v3': 'Certify v3.0',
              'v3GG': 'GPTW + GCTI'
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': 'Additional certifications',
            'SUBTIPOS': {
              'v1Amco': 'AMCO',
              'v2TD': 'Decent work',
              'v3PE': 'First Job',
            }
          },
          'medir': {
            'NOMBRE': 'Measure',
            'SUBTIPOS': {
              'v1': 'Measure v1',
              'v2': 'Measure improved',
              'v3': 'Measure + MST',
              'v4': 'Measure by areas',
              'v5': 'Measure by leaders',
              'v6': 'Measure by dimensions',
              'v7': 'Measure to certify',
              'v8': 'Measure 3.0',
            }
          },
          'pulse': {
            'NOMBRE': 'Press Check',
            'SUBTIPOS': {
              'v1': 'Pulse Check v1.0',
              'v2': 'Pulse Check v3.0',
            }
          },
          'focus': {
            'NOMBRE': 'Focus Area',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': 'Cultural Go Express',
            'SUBTIPOS': {
              'cgoExpress': 'Cultural Go Express'
            }
          },
          'medir_amco': {
            'NOMBRE': 'ICI Products',
            'SUBTIPOS': {
              'v1': 'ICI',
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow results',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow results'
            }
          },
          'swift': {
            'NOMBRE': 'Swift',
            'SUBTIPOS': {
              'swift': 'Swift'
            }
          }
        }
      },
      'DETALLES': {
        'TITULO': 'Product Details',
        'PRODUCTO': 'Product:',
        'PROGRESO': 'Progress',
        'RESTANTE': 'Time remaining',
        'DIASREST': 'Remaining days:',
        'PANELFIJO': 'Show as fixed panel',
        'SURVEYTOKEN': 'SurveyToken',
        'ACCOUNT_ID': 'Account ID',
        'OPORTUNITY_ID': 'Oportunity ID',
        'FECHAS': {
          'lanzamiento': 'Release date',
          'cierre': 'Deadline',
          'prorroga': 'Extension date',
          'recordatorio':'Reminders',
          'avisos':'Pre-survey communication',
        },
        'AVANCES': {
          'NORMAL': 'Advance responses:',
          'MAS50': 'Advance over 50:',
          'MAS50_2': 'Over 50 - Advance Answers',
          'MENOS50': 'Advance less than 50:',
          'MENOS50_2': 'Less than 50 - Advance responses'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': 'Choose a product',
          'VERPROD_2': 'See another product',
          'OCULTAR': 'Hide'
        },
        'PREVIA': {
          'TITULO': 'Survey status by product',
          'SUBTITULO': 'The list of products purchased by this company is shown in the menu on the left of this screen. To see the survey status for each product, click on a product category and then choose a year. After this, the details of the selected survey will be displayed, only if the selected product already has an initialized survey',
          'CARGANDO': 'Retrieving status of the selected product, please wait'
        },
        'ESTADOS': {
          'NOCREADA': 'This product does not have a survey created yet',
          'NOINICIADA': 'Survey not enabled'
        },
      },
      'COLABORADORES': {
        'TAB': 'List of collaborators',
        'CARGANDO': 'Loading list of collaborators',
        'TABLA': {
          'TITULO': 'List of collaborators',
          'NOINFO': 'No information',
          'COLUMNAS': {
            'NOMBRE': 'Full name',
            'EMAIL': 'Email',
            'PASS': 'Password',
            'STATUS': 'Actual state',
            'FECHA_INI': 'Start date',
            'FECHA_FIN': 'Finish date',
            'ACCIONES': 'Actions'
          },
          'TOOLTIPS': {
            'ACCIONES': 'Available Actions',
            'EMAILS': 'Email log',
          },
        },
        'ACCIONES': {
          'TITULO': 'Available Actions',
          'LISTA': {
            'primerosColab': 'See first 1000',
            'buscarColab': 'Find a collaborator',
            'nuevoColab': 'Add new collaborator',
            'enviaReco': 'Send reminders',
            'bajarColab': 'Download list of collaborators',
          }
        },
        'SENDGRID': {
          'TITULO': 'Sent mail log',
          'SUBTITULO': 'Choose a subject type from the list to show the history of sent emails',
          'SELOPC': 'Select an option',
          'INFOASUNTO': {
            'TITULO': 'Mail information',
            'CARD': {
              'from': 'Send to',
              'to': 'From',
              'subject': 'Message Subject'
            },
            'HISTORIAL': {
              'TITULO': 'Email submission history',
              'SUBTITULO': 'NOTE: The date / time displayed in the list is set to local time from',
              'VECESABIERTO': 'Times open',
              'ULTIMOEVENTO': 'Last event',
              'NORECORDS': 'Your email history is not available',
              'STATUS': {
                'ABIERTO': 'Email sent',
                'NOENVIADO': 'Not sent yet'
              }
            }
          },
          'BOTONES': {
            'BACK': 'Go back'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': 'Available Actions',
          'SUBTITULO': 'The following list shows the list of actions available to the user',
          'CARGANDO': 'Loading available actions',
          'LISTA': {
            'modificar': 'Modify the data of the selected collaborator',
            'borrar': 'Delete the selected collaborator',
            'invitacion': 'Resend invitation',
            'recordatorio': 'Resend reminder',
            'respuestas': 'Remove survey response',
            'resetSur': 'Reset survey access',
          }
        },
        'MODALES': {
          'BUSCAR': 'Enter the name of the collaborator to search',
          'BUSCAR_BOT': 'Search',
          'MINIMARECO': 'Reminders can only be sent from the survey launch date',
          'GENERAEXCEL': 'Generating excel file of collaborators, wait a moment',
          'NOANSWERS': 'No responses were found for this participant',
          'ENVIOCORREO': 'Sending the message, wait a moment',
          'BORRARESP': 'Deleting replies from this user, please wait a moment',
        },
        'EXCEL': {
          'TITUARCHIVO': 'List of collaborators',
          'COLUMNAS': {
            'name': 'Collaborator name',
            'email': 'Email',
            'id_status': 'Survey status',
            'start_date': 'Start date',
            'end_date': 'Finish date',
          }
        }
      },
      'ACCIONES': {
        'TAB': 'Actions',
        'TITULO': 'List of actions available by category',
        'CATEGORIAS': {
          'encuesta': 'Survey',
          'filemanager': 'File manager',
          'resultados': 'Results',
          'cultureaudit': 'Culture Audit',
          'webcompro': 'Company profile on the web',
        },
        'LISTA': {
          'surveyCheck': 'Survey check',
          'surveyDown': 'Download survey',
          'goSurvey': 'Go to survey',
          'goCounting': 'Go to the Counts Portal',
          'goCounting_more50': 'Go to the Counts Portal +50',
          'goCounting_less50': 'Go to the Counts Portal -50',
          'genCountingUrl': 'Generate external link to the Counts Portal',
          'copyCountingUrl': 'Copy external link to the Counts portal',
          'updateCounting': 'Synchronize with Counts portal',
          'addPro': 'Add extension',
          'verRecord': 'Recorded reminders',
          'surveyClose': 'Close survey',
          'surveyOpen': 'Open survey',
          'processRes': 'Process results',
          'goPriv': 'View private folder',
          'goPub': 'View public folder ',
          'masterTable': 'Master table check',
          'verRes': 'View results',
          'upNameIcon': 'Update name and logo',
          'regCertifi': 'Regenerate certificate',
          'goSurveyMas50': 'Go to survey +50',
          'goSurveyMenos50': 'Go to survey -50',
          'auditMan': 'Manual audit',
          'libeCultureBrief': 'Culture Brief Release',
          'lockRes': 'Lock results',
          'verCultureAudit': 'See Culture Audit',
          'verAvisos':'Pre-survey communication',
          'enviaCorreos': 'Send emails manually',
          'verWebComPro': 'View company profile on the web',
          'verFechIniCie': 'Start / end date',
          'cancelarEnvios': 'Cancel sending emails',
          'verConfigResult': 'Result configuration',
          'descaDemo': 'Allow demographics to be downloaded',
          'crearClave':'Generate key to external company profile',
          'copyClave':'Copy key to external company profile',
          'verDatWPC':'View external company profile access data',
          'confirReviCultureAudit':'Confirm Culture Audit review',
          'cambiaCultureBrief': 'Culture Audit Brief product link up'
        },
        'MODALES': {
          'URL': 'Link copied to clipboard',
          'URL_CLA': 'Se copio la clave al portapapeles',
          'CHANGE_RESULT':'Loading results',
          'LOADINGMASTER': 'Retrieving information from the Master Table, please wait a moment',
          'CONFIR_UPDA_NAM':'Are you sure you want to update the name and logo?',
          'CONFIR_REG_CERT':'Are you sure to regenerate certificate?',
          'SUCC_UPDA_NAME':'Successfully updated',
          'UPDA_NAME_ICON':'Update data',
          'UPDA_STA_ENC':'Updating survey status',
          'OBT_DAT_AUD_AUT':'Obtaining audit information',
          'WARNI_NOT_EXIT_TOKEN':'Error: token does not exist in MT',
          'CONFIR_REPRO_RESULT':'Are you sure to reprocess the results?',
          'MOD_INGRE_COD_PT1':'<span> To confirm, enter the code in red in the text box ',
          'MOD_INGRE_COD_PT2':'</span>',
          'ERROR_CODIGO': 'The code entered does not match the one indicated in red',
          'CONFIR_LIBE_CULT_BRI':'Are you sure to release the culture brief?',
          'CONFIR_REVI_CULT_AUDIT':'Are you sure to confirm the Culture Audit review?',
          'NO_CONFIR_REVI_CULT_AUDIT':'Are you sure to cancel the Culture Audit review?',
          'NO_CULT_BRI_ASOC':'No associated Culture Audit found',
          'BLOQUEAR_1_1': 'Results are currently unlocked \nDo you want to lock results?',
          'BLOQUEAR_1_2': 'Enter the reason why the results were blocked',
          'BLOQUEAR_2_1': 'Results are currently locked \nDo you want to unlock the results?',
          'BLOQUEAR_2_2': 'Write the reason why the results have been unlocked',
          'BLOQUEAR_3_1': 'It is necessary to specify the reason for the change',
          'SINCRONIZARMT': 'The data of the Master Table is being synchronized, please wait a moment',
          'UPDA_DAT_RECOR': 'Updating reminder date',
          'DELE_DAT_RECOR': 'Deleting reminder date',
          'UPDA_DAT_AVI': 'Updating notice date',
          'DELE_DAT_AVI': 'Eliminating notice date',
          'CANCELAR_ENVIOS': 'Are you sure you want to cancel the sending of scheduled emails?',
          'CANCELAR_ENVIOS_OK': 'The mailing was successfully canceled',
          'CANCELAR_ENVIOS_ERROR': 'It is not possible to cancel the mailing less than two hours before the launch of the survey',
          'COM_CRE_ACCE_WCP_EXT': 'Are you sure to create the key for the company profile?',
          'CRE_ACCE_WCP_EXT': 'Generating password',
          'SUCC_CRE_ACCE_WCP_EXT': 'Password successfully generated',
          'TIT_MOD_VALI_ACCE_WCP_EXT': 'To continue: Enter your password',
          'PLA1_MOD_VALI_ACCE_WCP_EXT': 'You currently have ',
          'PLA2_MOD_VALI_ACCE_WCP_EXT': ' attempts left',
          'BTN_ACEP': 'Accept',
          'BTN_CAN': 'Cancel',
          'WAR_ACCE_WCP_EXT': 'The password entered is not correct',
          'LIMI_ACCE_WCP_EXT': 'You have reached the limit of attempts',
          'DESAC_ACCE_WCP_EXT': 'Your company profile is currently disabled',
          'ACTU_ACCE_WCP_EXT': 'Updating information',
          'SUCC_ACTU_ACCE_ACCE_WCP_EXT': 'Successfully updated',
          'CHANGE_WCP':'Loading company profile',
        },
        'SUBACCIONES': {
          'TITULO': 'Click here to see more available actions',
          'AUDMANUAL': {
            'TITULO': 'Manual audit',
            'NOMBRE': 'Auditor\'s name',
            'NOTAS': 'Observations',
            'STATUS': {
              'ON': 'Audit accepted',
              'OFF': 'Audit rejected'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': 'Change results version type',
              'MODAL': {
                'TITULO': 'Version type selection',
                'SUBTITULO': 'Select the type of results version for this product',
                'SINCERT': 'Version without certificate',
                'CONCERT': 'Version with certificate'
              }
            },
            'tipoResuV2': {
              'TITULO': 'See results version 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': 'Change certificate logo',
            },
            'previewCert': {
              'TITULO': 'Certificate preview',
            },
            'multiSite': {
              'TITULO': 'Enable multi-site certificate text',
            },
            'multiSiteText': {
              'TITULO': 'View multi-site certificate text',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': 'Change company logo'
            },
            'previewLogoEmp': {
              'TITULO': 'Logo preview'
            },
            'updateDatCerti': {
              'TITULO': 'Change certificate date',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': 'Synchronize Master Table'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': 'Status see external company profile',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': 'Status see external company profile',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': 'Status see company profile on the website',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'Public',
              'ESTA_WPC_NPU':'Non-public',
            },
          },
          'cambiaCultureBrief': {
            'TITULO': 'Culture Audit Brief product link up',
            'STATUS_SIN': 'Currently this product does not have a linked up Culture Audit Brief product',
            'STATUS_CON': 'Currently linked up product',
            'BOTON_ELEGIR': 'Link up a product Culture Audit Brief',
            'BOTON_ELEGIR_2': 'Confirm',
            'BOTON_CAMBIAR': 'Link up with another product Culture Audit Brief',
            'LISTA_ELEGIR': 'Choose a Culture Brief product from the list',
            'LISTA_DISPONIBLES': 'Products available',
            'SIN_OPCIONES': 'No products available',
            'MESSAGE3': '<span>To confirm the selected Culture Audit Brief product link up, enter the text in red in the text box:',
            'MESSAGE4': '</span>',
            'MESSAGE5': 'The selected Culture Audit Brief product was successfully linked up with your Certify product',
            'VALIDAR': 'Confirm',
            'SALIR': 'Cancel',
            'ERRORNOMBREEMPRESA': 'The text entered does not match the text indicated in red',
            'CERRAR': 'Close',
          }
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': 'History of sent emails',
        'TITULO': 'List of emails sent for this product',
        'TABLA': {
          'DESTINATARIO': 'Addressee',
          'ASUNTO': 'Mail subject',
          'ESTADO': 'Current status',
          'VECES': 'Number of times opened',
          'ULTIMO': 'Date of the last event',
          'FILTRO': 'Filter',
          'INPUT_DEST': 'Filter by email address',
          'INPUT_ASU': 'Filter by subject',
          'INPUT_STAT': 'Filter by status',
          'ELIJAOPCION': '- Choose an option from the list -',
          'NORESULTS': 'No records found',
          'LISTA_STATUS': {
            'delivered': 'Sent',
            'processed': 'In shipping process',
            'not_delivered': 'Not sent'
          }
        },
        'ACCIONES': {
          'TITULO': 'Available Actions',
          'LISTA': {
            'enviaCorreos': 'Send emails manually',
            'getEnviados': 'Update emails sending history',
          }
        },
        'MODAL': {
          'TITULO': 'Manual mailing',
          'SUBTITULO': 'You can send immediate manual mailings of a specific type to collaborators in this survey',
          'INPUT': 'Select a mail type',
          'TIPOS': {
            '1': 'Invitation email',
            '2': 'Reminder email',
            '3': 'First notice prior to launching the survey',
            '4': 'Second notice prior to launching the survey',
            '5': 'Closing Mail',
            '6': 'Mail sent to collaborators who have not started the survey yet',
            '7': 'Mail sent to collaborators who started but haven\'t finished'
          },
          'BOTONES': {
            'BACK': 'Go back',
            'CONTINUAR': 'Continue',
            'SAVE': 'Save audit',

          }
        },
        'MODALES': {
          'RECUPERANDO': 'Retrieving sent mails list, wait a moment',
          'SEND_EMA':'Sending mails',
          'SUCC_SEND_EMA':'The mails have been sent successfully',
          'CONFIRMAR': 'Do you confirm sending the emails of the selected type to the collaborators in this survey?',
          'ENVIADOS': 'The emails were sent successfully, update the history shortly to see the emails sent',
          'SI': 'Yes',
          'NO': 'No',
          'UPDAT_HIST_EMA': 'Updating history',
          'SUCC_UPDAT_HIST_EMA': 'Successfully updated',
          'WAR_SEL_MAI': 'To continue, select a mail type',
          'WAR_SQL_ERROR': 'Response time has expired, please try again',
        },
        'RESUMEN': {
          'TITULO': 'Summary',
          'TIPOS': {
            'totalEnviados': 'Total mailings started',
            'delivered': 'Correct mailings',
            'processed': 'Mailings in process',
            'not_delivered': 'Mailings not made',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'Survey audit',
        'TEX_AUDI_NOT_AUTORI': 'Audit rejected!',
        'TEX_AUDI_YE_AUTORI':'Audit accepted!',
        'TITL_AUDI_DEV_TR':'% Dev.Time Response',
        'TITL_AUDI_DEV_PC':'% Dev. Question Control',
        'TITL_AUDI_DEV_PA':'% Dev. Question Random',
        'TIT_PAGI_TABL':'Articles per page:',
        'COLUMNAS':{
          'HierarchicalPath':'Structure',
          'RespondentCount':'# Responses',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.Control',
          'ControlStatement_DeviationPercentage':'% Desv P.Control',
          'RandomStatement_DeviationPercentage':'# Desv P.Random',
          'RandomStatement_DeviationCount':'% Desv P.Random',

        }
      },
      'EMAI_LOG':{
        'TAB':'General mail history',
        'TABLA_GLOBAL':{
          'TITU':'Global display',
          'SUB_TIT':'Total contributors',
          'TH_1':'Status',
          'TH_2':'First notification',
          'TH_3':'Second notification',
          'TH_4':'Invitation',
          'TH_5':'Reminder to un-started users',
          'TH_6':'Reminder for unfinished users',
          'enviados':'Sent',
          'procesando':'processed',
          'error':'Error',
          'VIE_DETA_TOOL':'View details',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': 'Display of sent warning 1 type of mail',
          'TITU_AV1_PROCC':'Display mail type notification 1 in process',
          'TITU_AV1_N_DELIV':'Display type of mail warning 1 in error',

          'TITU_AV2_DELIV': 'Display type of mail warning 2 sent',
          'TITU_AV2_N_DELIV':'Display type of mail warning 2 in error',
          'TITU_AV2_PROCC': 'Display type 2 notification 2 mail in process',

          'TITU_INV_DELIV':'Display type of mail invitation sent',
          'TITU_INV_PROCC': 'Display type of invitation mail in process',
          'TITU_INV_N_DELIV': 'Display type of invitation mail in error',

          'TITU_REC1_DELIV':'Display reminder mail type 1 sent',
          'TITU_REC1_PROCC':'Display reminder 1 type of mail in process',
          'TITU_REC1_N_DELIV':'Display reminder 1 type of mail in error',

          'TITU_REC2_DELIV':'Display reminder mail type 2 sent',
          'TITU_REC2_N_DELIV':'Display reminder mail type 2 in error',
          'TITU_REC2_PROCC': 'Display reminder mail type 2 in process',
          'SUB_TIT':'Total collaborators',
          'TH_1':'Status',
          'TH_2':'Contributor name',
          'TH_3':'Message',
          'TH_4':'Date of last email',
          'TH_5':'Total mails',
          'TH_6':'Action',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'Enter name or e-mail',

        },
        'TEX_MOD_CHA_INFO':'Loading information',
        'CONT_MOD':{
          'TAB_TIT1':'Mail status',
          'TAB_TIT2':'Mail view',
          'TEX_CHA_INFO_GRAL':'Loading information',
          'TEX_ASUN':'Subject: ',
          'TEX_SELEC_EMA':'Select an e-mail',
          'TEX_CHA_INFO_EMA':'Loading mail information',
          'H1_TIT_EMA_INFO':'Email information',
          'SPAN_SUB_TIT_DET':'details',
          'TO':'To:',
          'FROM':'From:',
          'SUBJE':'Subject',
          'MESS_ID':'Message ID :',
          'BTN_VER_MAS':'More details',
          'BTN_VER_MEN':'Less details',
          'TIT_TEX_LIS':'Event History',
          'SPAN_RECIV_SENGR':'Received by SendGrid',
          'SPAN_RECIV_FROM':'Received by ',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'The recipient opened this mail',
          'REASON':{
           'Bounced Address':'Bounced Address',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD':'Modify certificate date',
        'ING_DAT':'Select date:',
        'ING_RAS':'Enter reason to modify date:',
        'BTN_SAV':'Save changes',
        'BTN_OK':'OK',
        'MOD_ING_REA':'Enter reason for date change',
        'MOD_UPD_DAT':'Updating certificate date',
        'SUCC_MOD_UPD_DAT':'Successfully updated',

      },
      'DAT_STAEND':{
        'TIT_MOD':'Survey start and end date',
        'SUB_TIT_MOD':'Each date is displayed in local time in ',
        'TEX_DA_STA':'Start date',
        'TEX_DA_EN':'End date',
        'MOD_UPD_DA_DA_STA':'Updating release date',
        'MOD_UPD_DA_EN':'Updating end date',
        'SUCC_MOD_UPD_DA_DA_STA':'Successfully updated',
        'SUCC_MOD_UPD_DA_DA_EN':'Successfully updated',

      },
      'LANG_CERT':{
        'TIT_MOD':'Select language:',
      },
    }
};
